import { Nav } from "reactstrap";
import Layout from "../../../custom/Layout";
import CustomNavItem from "../../../custom/CustomNavItem";
import { useEffect, useState } from "react";
import { TabContent } from "reactstrap";
import CustomTabPane from "../../../custom/CustomTabPane";
import TruckBuildup from "./TruckBuildup";
import Log from "./Log";
import useUnitedRoleRegister from "./useUnitedRoleRegister";

export type Tab = 'TRUCK_BUILDUP' | 'LOG';

export default function Buildup() {

    const [activeTab, setActiveTab] = useState<Tab>('TRUCK_BUILDUP');

    const toggleTab = (tab: Tab) => setActiveTab(tab);

    const { ready } = useUnitedRoleRegister();

    return (
        <Layout>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<Tab>
                    tabName="Truck Buildup"
                    tabId="TRUCK_BUILDUP"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<Tab>
                    tabName="Log"
                    tabId="LOG"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<Tab> tabId={'TRUCK_BUILDUP'}>
                    <TruckBuildup 
                        ready={ready}
                    />
                </CustomTabPane>
                <CustomTabPane<Tab> tabId={'LOG'}>
                    <Log activeTab={activeTab} />
                </CustomTabPane>
            </TabContent>
        </Layout>
    );
}